import React, { FC, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation, useParams } from 'react-router-dom';
import { Box, createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { PeakModules } from 'common/constants/peakModules';
import { RouteBackground } from 'components';
import { LeadProfile } from 'modules/crm/components';
import { selectPersonAdditionalFields } from 'common/components/PersonProfile/state/selectors';
import * as personActions from 'common/components/PersonProfile/state/actions';
import messages from 'modules/crm/messages/leads';
import ptCrmMessages from 'modules/personal-training-crm/messages/messages';
import { selectAdditionalInfoForUpdateResult } from 'common/state/newPerson/additionalInfo/selectors';
import useComponentDidUpdate from 'common/hooks/useComponentDidUpdate';
import { ActionResult } from 'common/constants';
import useRootSelector from 'common/hooks/useRootSelector';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      height: '100%',
    },
    pageTitle: {
      marginBottom: theme.spacing(1),
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(0, 2),
      },
    },
  }),
);

const LeadProfilePage: FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams();
  const personId = Number(id);

  const additionalFields = useRootSelector(selectPersonAdditionalFields(personId));
  const additionalInfoUpdateActionResult = useRootSelector(selectAdditionalInfoForUpdateResult);

  const classes = useStyles();

  const module =
    location.pathname.indexOf('personal-training-crm') === -1
      ? PeakModules.Crm
      : PeakModules.PersonalTrainingCrm;
  const isCrmModule = module === PeakModules.Crm;

  useEffect(() => {
    dispatch(personActions.getPersonAdditionalInfo(personId, module));
  }, [dispatch, personId, module]);

  useComponentDidUpdate(() => {
    if (additionalInfoUpdateActionResult === ActionResult.SUCCESS_ACTION) {
      dispatch(personActions.getPersonAdditionalInfo(personId, module));
    }
  }, [additionalInfoUpdateActionResult, id, module, dispatch]);

  return (
    <RouteBackground fullScreenView>
      <Box display="flex" flexDirection="column" className={classes.wrapper}>
        <Box className={classes.pageTitle} display="flex" alignItems="center">
          <Typography component="h1" variant="h2">
            <FormattedMessage
              {...(isCrmModule ? messages.leadProfileTitle : ptCrmMessages.ptLeadProfile)}
            />
          </Typography>
        </Box>

        <LeadProfile
          additionalFields={additionalFields}
          clientId="1"
          personId={personId}
          module={module}
        />
      </Box>
    </RouteBackground>
  );
};

export default LeadProfilePage;
